import React, {
  useEffect, useState, memo, useMemo, useCallback,
} from 'react'
import { useQuery } from 'react-query'
import axios from 'axios'
import {
  addIdProp, addTestIdProp,
} from 'utils/universal'
import { mapType } from 'utils/miscellaneous'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Typography } from '@mui/material'
import Swiper from 'components/common/Swiper'
import { FreeMode, Navigation } from 'swiper'
import { setFilters, setPage } from 'redux/modules/search'
import { useRouter } from 'next/router'
import { useIntl } from 'react-intl'
import clsx from 'clsx'
import useMediaQuery from '@mui/material/useMediaQuery'
import VehicleTypeItem from './VehicleTypeItem'
import HybridVehicle from './VehicleTypeItem/HybridVehicle'
import sx from './styles'

const VehicleTypes = (props) => {
  const {
    value = '',
    fuelValue = '',
    redirectToSRP = false,
    direction = 'row',
    title,
    titleStyles,
    variantTitle = 'h3',
    testId: testIdProp,
  } = props
  const filters = useSelector((s) => s.search.filters)
  const [bodies, setBodies] = useState([])
  const [fuels, setFuels] = useState([])
  const dispatch = useDispatch()
  const { formatMessage: f } = useIntl()
  const router = useRouter()
  const searchUrl = useMemo(() => f({ id: 'ROUTE_SEARCH' }), [])
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'))

  const handleFiltersChange = useCallback((changedFilters) => {
    dispatch(setPage(1))
    if (redirectToSRP) {
      let redirectTo = ''
      switch (changedFilters?.body || changedFilters.fuelType) {
        case 'Sedan 4 puertas':
          redirectTo = `${searchUrl}/tipo-Sedan%204%20puertas`
          break
        case 'Camioneta SUV':
          redirectTo = `${searchUrl}/tipo-Camioneta%20SUV`
          break
        case 'Hatchback':
          redirectTo = `${searchUrl}/tipo-Hatchback`
          break
        case 'Crossover':
          redirectTo = `${searchUrl}/tipo-Crossover`
          break
        case 'Coupe 2 puertas':
          redirectTo = `${searchUrl}/tipo-Coupe%202%20puertas`
          break
        case 'Pickup':
          redirectTo = `${searchUrl}/tipo-Pickup`
          break
        case 'Van':
          redirectTo = `${searchUrl}/tipo-Van`
          break
        case 'Convertible':
          redirectTo = `${searchUrl}/tipo-Convertible`
          break
        case 'hibrido-elec':
          redirectTo = `${searchUrl}/combustible-hibrido-elec`
          break
        default:
          redirectTo = searchUrl
          break
      }
      router.push(redirectTo)
    } else {
      dispatch(setFilters(changedFilters))
    }
  }, [redirectToSRP, searchUrl, filters])

  const vehicleElectricFilter = useMemo(() => fuels?.find((item) => item.slug === 'hibrido-elec'), [fuels])

  const metaFilters = useQuery(
    ['metaFilters', null],
    async () => {
      const req = await axios.get(
        `${process.env.NEXT_PUBLIC_API_ROOT}/api/filters?all_inventory=true&extense_info=true`,
      )
      return req.data
    },
    {
      staleTime: 1000 * 60 * 24,
      keepPreviousData: true,
    },
  )

  useEffect(() => {
    const response = mapType(metaFilters?.data?.bodies)
    setBodies(response?.bodies)
    setFuels(metaFilters?.data?.fuel)
  }, [metaFilters.data])

  return (
    <Box
      id="section5"
      {...addTestIdProp(testIdProp)}
      {...addIdProp(testIdProp)}
      pt={title ? 2 : 0}
      sx={sx.root}
    >
      {title && (
        <Typography
          sx={{ ...sx.bodyTypesTitle, ...titleStyles }}
          variant={variantTitle}
          className={clsx({
            column: direction === 'column',
          })}
        >
          {title}
        </Typography>
      )}
      <Swiper
        containerStyles={sx.swiperContainer}
        hideNavigationOnEnd
        items={vehicleElectricFilter ? bodies.concat(vehicleElectricFilter) : bodies}
        prefixIds="filter-type__"
        slidesPerView={isMobile ? 2 : 'auto'}
        spaceBetween={5}
        modules={[FreeMode, Navigation]}
        mousewheel
        renderItem={(item, index) => (index >= bodies.length ? (
          <HybridVehicle
            onChange={handleFiltersChange}
            item={item}
            value={fuelValue}
            showCloseButton={!redirectToSRP && filters?.fuelType?.includes(item?.slug)}
          />
        ) : (
          <VehicleTypeItem
            item={item}
            onChange={handleFiltersChange}
            value={value}
            showCloseButton={!redirectToSRP && filters?.body?.includes(item.name)}
          />
        ))}
      />
    </Box>
  )
}

export default memo(VehicleTypes)
